
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import SmsList from "@/views/sms/views/SmsList.vue";
import { MessageAPI } from "@/services/api/Message.service";
import SmsContent from "@/views/sms/views/SmsContent.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ISms } from "@/interfaces/iSms";
import { useRouter } from "vue-router";
import { iParticipant, ServerSMS } from "@/interfaces/iMessage";
import {
  MESSAGE_STORE,
  GET_PARTICIPANT_DETAIL,
  GET_CONVERSATION_DETAIL,
} from "@/store/message/types";
import { Actions } from "@/store/enums/StoreEnums";
import store from "@/store";
import { ICurrentUser } from "@/interfaces/iCurrentUser";

export default defineComponent({
  name: "private-chat",
  components: {
    SmsList,
    SmsContent,
  },
  setup() {
    const router = useRouter();
    const taskName = ref<any>([]);
    const selectedData = ref<ISms[]>([]);
    const currentUser = computed(() => {
      return store.getters.currentUser as ICurrentUser;
    });
    const isActiveUser = computed(() => {
      const key = `${MESSAGE_STORE}/${GET_PARTICIPANT_DETAIL}`;
      const participants = store.getters[key] as iParticipant[];
      return (
        participants.findIndex(
          (participant) =>
            `${participant.webId}` == `${currentUser.value.webId}` &&
            participant.status !== "INACTIVE"
        ) > -1
      );
    });
    const isActiveConversation = computed(() => {
      const key = `${MESSAGE_STORE}/${GET_CONVERSATION_DETAIL}`;
      const smsDetail = store.getters[key] as ServerSMS;
      return smsDetail.status === "OPEN";
    });
    const getSmsDetails = async (smsData) => {
      selectedData.value[0] = smsData;
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      taskName.value = await MessageAPI.getInstance().fetchConversationTaskName(
        smsData.webId
      );
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Chat", ["Home", "Chat"]);
    });
    watch(
      selectedData,
      async (val) => {
        if (val && val[0]) {
          router.push({ name: "sms.detail", params: { id: val[0].webId } });
        }
      },
      { deep: true }
    );
    return {
      selectedData,
      currentUser,
      isActiveUser,
      isActiveConversation,
      taskName,
      getSmsDetails,
    };
  },
});
